import React, { useContext, useEffect, useState } from 'react';
import './donneesAdmin.css';
import AppelerApi from '../../../services/appeler-api.service';
import { Box, Button, Checkbox, Modal, Snackbar, TextField } from '@mui/material';
import AjouterIcone from '@mui/icons-material/AddBox';
import ChoisirIcone from '@mui/icons-material/Input';
import SupprimerIcone from '@mui/icons-material/Delete';
import Select from 'react-select';
import debounce from 'lodash.debounce';
import { baseSelectionneeContext } from '../../../App';
import notificationService from '../../../services/notification.service';

const DonneesAdmin = () => {

    const { baseSelectionnee } = useContext(baseSelectionneeContext);
    const [valeurEntree, _] = useState('');
    const [afficherEnregistrement, setAfficherEnregistrement] = React.useState(false);
    const [admins, setAdmins] = useState([]);
    const [admin, setAdmin] = useState('');
    const [parametres, setParametres] = useState({});
    const [nouvelAdminOuvert, ouvrirNouvelAdmin] = useState(false);
    const [saisieNouvelAdminLogin, setNouvelAdminLogin] = useState('');
    const [saisieNouvelAdminLibelle, setNouvelAdminLibelle] = useState('');
    const [saisieNouvelAdminModele, setNouvelAdminModele] = useState({});
    const [saisieNouvelAdminEmail, setNouvelAdminEmail] = useState('');
    const [optionsModelesAdmin, setOptionsModelesAdmin] = useState([]);
    const [listeSalons, setListeSalons] = useState([]);
    const [ajoutSalonOuvert, ouvrirAjoutSalon] = useState(false);
    const [salons, setSalons] = useState([]);
    const [messageEnleverSalon, afficherMessageEnleverSalon] = useState(false);
    const [listeModelesSousGroupes, changerModelesSousGroupes] = useState([]);

    const listeCriteres = [{ value: 'LOGIN', label: 'Admin par login' }, { value: 'ADMIN', label: 'Tous comptes admin' }];
    const [critere, setCritere] = useState(listeCriteres[0]);

    const modifierCritere = (critere) => {
        setCritere(critere);
        chercherAdmin(critere); // Pour critères sans filtre associé
    };

    const rechercheParChaine = debounce((chaine, critereOptionnel) => {
        chercherAdmin(critereOptionnel ?? critere, chaine);
    }, 500);

    const rechercheSalonParChaine = debounce((chaine) => {
        chercherSalon(chaine);
    }, 500);

    const chercherAdmin = (critere, valeurFiltre) => {
        switch (critere.value) {
            case 'LOGIN':
                if (!valeurFiltre || valeurFiltre.length < 3) {
                    return;
                }
                AppelerApi.get('/lire-clients-par-enseigne', { enseigne: valeurFiltre, admin: true }).then(data => {
                    setAdmins(data.clients);
                });
                return;
            case 'ADMIN':
                AppelerApi.get('/lire-admins').then(data => {
                    setAdmins(data.clients);
                });
                return;
        }
    };

    const chercherSalon = (valeurFiltre) => {
        if (!valeurFiltre || valeurFiltre.length < 3) {
            return;
        }
        AppelerApi.get('/lire-clients-par-enseigne', { enseigne: valeurFiltre }).then(data => {
            setSalons(data.clients);
        });
    };

    const selectionnerAdmin = (enseigne) => {
        setAdmin(enseigne);
        AppelerApi.get('/lire-parametres-admin', { enseigne: enseigne }).then(data => {
            setParametres(data);
            if (data.Modeles_Droits) {
                changerModelesSousGroupes(optionsModelesAdmin.filter(option => data.Modeles_Droits.includes(option.value)));
            } else {
                changerModelesSousGroupes([]);
            }
            AppelerApi.get('/lire-liste-salons-dans-admin', { enseigne: enseigne }).then(liste => {
                setListeSalons(liste);
            });
        });
    };

    const appliquerModificationParametre = debounce((champ, valeur) => {
        AppelerApi.post('/modifier-parametre-admin', { enseigne: admin, champ, valeur }).then(() => {
            setAfficherEnregistrement(true);
        });
    }, 700);

    const modifierParametre = (champ, valeur) => {

        const nouveauParametre = {};
        nouveauParametre[champ] = valeur;
        setParametres({ ...parametres, ...nouveauParametre });

        appliquerModificationParametre(champ, valeur);
    };

    const masquerEnregistrement = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAfficherEnregistrement(false);
    };

    const enregistrerNouvelAdmin = () => {
        AppelerApi.post('/creer-admin', { enseigne: saisieNouvelAdminLogin, libelle: saisieNouvelAdminLibelle, modele: saisieNouvelAdminModele.value, email: saisieNouvelAdminEmail }).then((resultat) => {
            if (resultat.erreur) {
                notificationService.afficher(resultat.erreur);
                return;
            }
            modifierCritere(listeCriteres[0]);
            rechercheParChaine(saisieNouvelAdminLogin, listeCriteres[0]);
        });
        ouvrirNouvelAdmin(false);
    };

    const ajouterSalon = (enseigne) => {
        AppelerApi.post('/ajouter-salon-dans-admin', { ID_Consolide: parametres.ID_Consolide, enseigne, Admin_Grand_Groupe: !!parametres.Admin_Grand_Groupe }).then(() => {
            selectionnerAdmin(parametres.ID_Consolide);
            setAfficherEnregistrement(true);
        });
        ouvrirAjoutSalon(false);
    };

    const enleverSalon = (enseigne) => {
        AppelerApi.post('/enlever-salon-dans-admin', { ID_Consolide: parametres.ID_Consolide, enseigne }).then(() => {
            setListeSalons(listeSalons.filter(salon => salon.ID_Enseigne !== enseigne));
            setAfficherEnregistrement(true);
        });
        afficherMessageEnleverSalon(false);
    };

    const modifierListeModelesSousGroupes = (listeModeles) => {
        changerModelesSousGroupes(listeModeles);
        appliquerModificationParametre('Modeles_Droits', JSON.stringify(listeModeles.map(modele => modele.value)));
    };

    const seConnecter = (IDConsolide, preprod = false) => {
        const urlAppel = (baseSelectionnee === 'DEV' ? 'https://test.hairnetplus.app/lire-token-auth-admin' : (preprod ? 'https://preprod.hairnetplus.app/lire-token-auth-admin' : 'https://hairnetplus.app/lire-token-auth-admin'));
        fetch(urlAppel, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'gi7AyOmQG2njzTqxU7NOc7D'
            },
            credentials: 'include',
            mode: 'cors',
            body: JSON.stringify({ IDConsolide: IDConsolide })
        })
        .then(async reponse => {
            if (reponse.status >= 400) {
                return reponse.json().then(donnees => { return { codeHttp: reponse.status, ...donnees }; });
            } else {
                return reponse.json();
            }
        })
        .then(auth => {
            const newTab = window.open('', '_blank');
            const host = (baseSelectionnee === 'DEV' ? 'https://admin.test.hairnetplus.app' : (preprod ? 'https://admin.preprod.hairnetplus.app' : 'https://admin.hairnetplus.app'));
            const url = `${host}/login;token=${auth.token}`;
            newTab.location.href = url;
        });
    };

    useEffect(() => {
        AppelerApi.get('/lire-feature-flags-modeles', { flagsPermanents: true }).then(data => {
            const optionsModelesAdmin = [];
            for (const modele of data.modeles) {
                if (modele.Admin) {
                    optionsModelesAdmin.push({ value: modele.ID_Enseigne, label: modele.Nom_Modele });
                }
            }
            setOptionsModelesAdmin(optionsModelesAdmin);
        });
    }, [valeurEntree, baseSelectionnee]);
    return (
        <div className="conteneur-admin">
            <h1>Données Admin <AjouterIcone className="ajouter-admin" onClick={_ => ouvrirNouvelAdmin(true)}/></h1>
            <div className="page">
                <div className="bloc-recherche">
                    <div className="recherche-client">
                        <h3>Recherche</h3>
                        <Select
                            placeholder="Critère"
                            className="selection"
                            value={critere}
                            options={listeCriteres}
                            onChange={modifierCritere}
                        />
                        { (critere.value === 'LOGIN') &&
                            <TextField onChange={event => rechercheParChaine(event.target.value)} className="saisie-une-ligne"/>
                        }
                    </div>
                    {
                    (<div className="tableau-clients"><table>
                        <thead>
                            <tr>
                                <th scope="col">Admin</th>
                                <th scope="col">Sélectionner</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(admins).map(([index, admin]) =>
                                <tr key={admin.ID_Consolide} className="ligne-activation">
                                    <td>{admin.ID_Consolide}</td>
                                    <td><ChoisirIcone className="icone" onClick={_ => selectionnerAdmin(admin.ID_Consolide)}/></td>
                                </tr>
                            )}
                        </tbody>
                    </table></div>)
                    }
                </div>
                <div className="bloc-client">
                    {(admin !== '' && parametres?.ID_Consolide &&
                    <div className="parametres-admin">
                        <h2>{parametres.Libelle_Regroupement}</h2>
                        <div className="champ-saisie">
                            <label>Nom de l'admin</label>
                            <TextField className="saisie-une-ligne" value={parametres.Libelle_Regroupement} onChange={e => modifierParametre('Libelle_Regroupement', e.target.value)}/>
                        </div>
                        <div className="champ-saisie">
                            <label>Email de récupération</label>
                            <TextField className="saisie-une-ligne" value={parametres.emailRecuperation} onChange={e => modifierParametre('emailRecuperation', e.target.value)}/>
                        </div>
                        <div className="champ-saisie">
                            <label>Nom du gérant</label>
                            <TextField className="saisie-une-ligne" value={parametres.Nom_Gerant} onChange={e => modifierParametre('Nom_Gerant', e.target.value)}/>
                        </div>
                        <div className="champ-saisie">
                            <label>Prénom du gérant</label>
                            <TextField className="saisie-une-ligne" value={parametres.Prenom_Gerant} onChange={e => modifierParametre('Prenom_Gerant', e.target.value)}/>
                        </div>
                        <div className="champ-saisie">
                            <label>Téléphone du gérant</label>
                            <TextField className="saisie-une-ligne" value={parametres.Telephone_Gerant} onChange={e => modifierParametre('Telephone_Gerant', e.target.value)}/>
                        </div>
                        <div className="champ-saisie">
                            <label>Bloquer</label>
                            <Checkbox checked={!!parametres.Bloquer} onChange={e => modifierParametre('Bloquer', !parametres.Bloquer)}/>
                        </div>
                        <div className="champ-saisie">
                            <label>Tarif d'un SMS unitaire</label>
                            <TextField className="saisie-une-ligne" value={parametres.Tarif_SMS_Unitaire} onChange={e => modifierParametre('Tarif_SMS_Unitaire', e.target.value)}/>
                        </div>
                        <div className="champ-saisie">
                            <label>Se connecter</label>
                            {(baseSelectionnee === 'PROD' && localStorage.getItem('Acces_Preprod') === '1' &&
                                <ChoisirIcone className="icone preprod" onClick={_ => seConnecter(parametres.ID_Consolide, true)}/>
                            )}
                            <ChoisirIcone className="icone" onClick={_ => seConnecter(parametres.ID_Consolide)}/>
                        </div>
                        <div className="champ-saisie">
                            <label>Admin grand groupe</label>
                            <Checkbox checked={!!parametres.Admin_Grand_Groupe} onChange={e => modifierParametre('Admin_Grand_Groupe', !parametres.Admin_Grand_Groupe)}/>
                        </div>
                        {(!!parametres.Admin_Grand_Groupe && 
                            <div className="champ-saisie">
                                <label>Modèles de droits des sous-groupes</label>
                                <Select
                                    isMulti
                                    value={listeModelesSousGroupes}
                                    onChange={modifierListeModelesSousGroupes}
                                    options={optionsModelesAdmin}
                                    styles={{control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        minWidth: '250px',
                                        maxWidth: '600px',
                                    })}}
                                >
                                </Select>
                            </div>
                        )}
                    </div>
                    )} {(admin !== '' && parametres?.ID_Consolide &&
                    <div className="parametres-admin">
                        <h2>Salons inclus</h2>
                        <div className="liste-salons">
                            <div className="liste-interieure">
                                <div className="element-salon">
                                    <AjouterIcone className="ajout-salon" onClick={() => ouvrirAjoutSalon(true)}></AjouterIcone>
                                </div>
                                {listeSalons.map(salon =>
                                    <div key={salon.ID_Enseigne} className="element-salon">
                                        {salon.Raison_sociale}{salon.Codepostal ? ` (${salon.Codepostal})` : ''}, login: {salon.ID_Enseigne}
                                        <SupprimerIcone onClick={() => afficherMessageEnleverSalon(salon.ID_Enseigne)}></SupprimerIcone>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    )}
                </div>
            </div>
            <Modal open={nouvelAdminOuvert} onClose={_ => ouvrirNouvelAdmin(false)}>
                <Box className="pop-up">
                    <div className="parametres-nouvel-admin">
                        <TextField placeholder="Login de l'admin (copier/coller)" onChange={e => setNouvelAdminLogin(e.target.value) }/>
                        <TextField placeholder="Libellé de l'admin" onChange={e => setNouvelAdminLibelle(e.target.value) }/>
                        <Select
                            placeholder="Modèle à appliquer"
                            options={optionsModelesAdmin}
                            onChange={e => setNouvelAdminModele(e)}
                        />
                        <TextField placeholder="E-mail de récupération" onChange={e => setNouvelAdminEmail(e.target.value) }/>
                    </div>
                    <div className="boutons-pop-up">
                        <Button onClick={_ => ouvrirNouvelAdmin(false)}>Annuler</Button>
                        <Button onClick={enregistrerNouvelAdmin} disabled={!saisieNouvelAdminModele.value || saisieNouvelAdminLogin.length === 0 || saisieNouvelAdminLibelle.length === 0 || saisieNouvelAdminEmail.length === 0}>Créer</Button>
                    </div>
                </Box>
            </Modal>
            <Modal open={ajoutSalonOuvert} onClose={_ => ouvrirAjoutSalon(false)}>
                <Box className="pop-up">
                    <div className="">
                        <h3>Recherche</h3>
                        <TextField onChange={event => rechercheSalonParChaine(event.target.value)} className="saisie-une-ligne"/>
                    </div>
                    {
                    (<div className="tableau-clients"><table>
                        <thead>
                            <tr>
                                <th scope="col">Salon</th>
                                <th scope="col">Sélectionner</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(salons).map(([index, client]) =>
                                <tr key={client.ID_Enseigne} className="ligne-activation">
                                    <td>{client.ID_Enseigne}</td>
                                    <td><ChoisirIcone className="icone" onClick={_ => ajouterSalon(client.ID_Enseigne)}/></td>
                                </tr>
                            )}
                        </tbody>
                    </table></div>)
                    }
                    <div className="boutons-pop-up">
                        <Button onClick={_ => ouvrirAjoutSalon(false)}>Fermer</Button>
                    </div>
                </Box>
            </Modal>
            <Modal open={!!messageEnleverSalon} onClose={() => afficherMessageEnleverSalon(false)}>
                <Box className="pop-up">
                    <p>Êtes-vous sûr de vouloir enlever le salon {messageEnleverSalon} de l'admin ?</p>
                    <p>Les prestations et remises partagées seront enlevées, les clients partagés seront "coupés en deux".</p>
                    <p>Cela peut prendre un certain temps.</p>
                    <div className="boutons-pop-up">
                        <Button onClick={() => afficherMessageEnleverSalon(false)}>Annuler</Button>
                        <Button onClick={() => enleverSalon(messageEnleverSalon)}>Confirmer</Button>
                    </div>
                </Box>
            </Modal>
            <Snackbar className="notification" open={afficherEnregistrement} onClose={masquerEnregistrement} autoHideDuration={1500} message={'Modification enregistrée'}/>
        </div>
    );
};

export default DonneesAdmin;